import { Component, NgZone, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { GoogleLoginApiService } from "../auth/google/googleLoginApiService";
import { initializeCoreServices } from "../util/initApp";
import { AccessManagerCfgService } from "../auth/accessManager/accessManagerCfg.service";
import { SigV4CfgService } from "../auth/aws/sigv4Cfg.service";
import { FeaturePermissionsCfgService } from "../auth/raas/featurePermissionsCfg.service";
import { ImpersonationService } from "../auth/apigee/impersonation.service";
import { AppLinksCfgService } from "../common/appLinks/appLinksCfg.service";
import { AppLinksProfessionalsCfgService } from "../common/appLinks/appLinksProfessionalsCfg.service";
import { HelpCfgService } from "../common/help/helpCfg.service";
import { LauncherCfgService } from "../common/launcher/launcherCfg.service";
import { NotificationHubCfgService } from "../common/notificationHub/notificationHubCfg.service";
import { OfficeSelectorCfgService } from "../common/officeSelector/officeSelectorCfg.service";
import { CommonCfgService } from "../common/rest/common-cfg.service";
import { SmsCfgService } from "../common/sms/smsCfg.service";
import { ServerAddressesCfgService } from "../util/serverAddressesCfg.service";
import { DashboardRecruitmentCfgService } from "../dashboard-recruitment/services/dashboard-recruitment-cfg.service";
import { DashboardCfgService } from "../dashboard/dashboardCfg.service";
import { AbsencesKpiCfgService } from "../dashboard/kpi/services/absencesKpi/absencesKpiCfg.service";
import { AdministrativeManagementDigitalizationKpiCfgService } from "../dashboard/kpi/services/administrativeManagementDigitalizationKpi/administrativeManagementDigitalizationKpiCfg.service";
import { BucketStatusKpiCfgService } from "../dashboard/kpi/services/bucketStatusKpi/bucketsStatusKpiCfg.service";
import { ContractsKpiCfgService } from "../dashboard/kpi/services/contractsKpi/contractsKpiCfg.service";
import { DiscontinuousPermanentWorkersKpiCfgService } from "../dashboard/kpi/services/discontinuousPermanentWorkersKpi/discontinuousPermanentWorkersKpiCfg.service";
import { MonthlyTargetsKpiCfgService } from "../dashboard/kpi/services/monthlyTargetsKpi/monthlyTargetsKpiCfg.service";
import { OccupationalRiskPreventionKpiCfgService } from "../dashboard/kpi/services/occupationalRiskPreventionKpi/occupationalRiskPreventionKpiCfg.service";
import { OffersInNegotiationKpiCfgService } from "../dashboard/kpi/services/offersInNegotiationKpi/offersInNegotiationKpiCfg.service";
import { OrdersKpiCfgService } from "../dashboard/kpi/services/ordersKpi/ordersKpiCfg.service";
import { PendingOrdersFDKpiCfgService } from "../dashboard/kpi/services/pendingOrdersFDKpi/pendingOrdersFDKpiCfg.service";
import { VisitsCallsTargetsKpiCfgService } from "../dashboard/kpi/services/visitsCallsTargetsKpi/visitsCallsTargetsKpiCfg.service";
import { WorkersAppealKpiCfgService } from "../dashboard/kpi/services/workersAppealKpi/workersAppealKpiCfg.service";
import { AbsencesDirectKpiCfgService } from "../dashboardDirect/kpi/services/absencesKpi/absencesDirectKpiCfg.service";
import { ContractsDirectKpiCfgService } from "../dashboardDirect/kpi/services/contractsKpi/contractsDirectKpiCfg.service";
import { OccupationalRiskPreventionDirectKpiCfgService } from "../dashboardDirect/kpi/services/occupationalRiskPreventionKpi/occupationalRiskPreventionDirectKpiCfg.service";
import { NoveltyCfgService } from "../novelties/services/novelty-cfg.service";
import { VacanciesKpiCfgService } from "../vacancies/services/vacanciesKpiCfg.service";
import { PowerBiCfgService } from "../common/launcher/powerbi/services/powerbi-cfg.service";
import { ShowPowerBiCfgService } from './../common/launcher/powerbi/services/showPowerbi-cfg.service';
import { ImpersonationCfgService } from "../auth/apigee/impersonationCfg.service";
import { ApigeeService } from "../auth/apigee/apigee.service";
import { switchMap } from "rxjs/operators";
import { of } from "rxjs";

@Component({
  selector: "app-login-success",
  templateUrl: "./loginSuccess.component.html",
  styleUrls: ["./loginSuccess.component.css"],
  standalone: false
})
export class LoginSuccessComponent implements OnInit {
  private mBusy: boolean = false;

  constructor(private gapisService: GoogleLoginApiService,
    private apigeeService: ApigeeService,
    private router: Router,
    private zone: NgZone,
    private serverAddressesCfgService: ServerAddressesCfgService,
    private accessManagerCfgService: AccessManagerCfgService,
    private impersonationService: ImpersonationService,
    private featurePermissionsCfgService: FeaturePermissionsCfgService,
    private sigv4CfgService: SigV4CfgService,
    private appLinksCfgService: AppLinksCfgService,
    private appLinksProfessionalsCfgService: AppLinksProfessionalsCfgService,
    private officeSelectorCfgService: OfficeSelectorCfgService,
    private helpCfgService: HelpCfgService,
    private launcherCfgService: LauncherCfgService,
    private smsCfgService: SmsCfgService,
    private notificationHubCfgService: NotificationHubCfgService,
    private impersonationCfgService: ImpersonationCfgService,
    private absencesKpiCfgService: AbsencesKpiCfgService, private dashboardCfgService: DashboardCfgService,
    private administrativeManagementDigitalizationKpiCfgService: AdministrativeManagementDigitalizationKpiCfgService, private bucketStatusKpiCfgService: BucketStatusKpiCfgService,
    private contractsKpiCfgService: ContractsKpiCfgService, private occupationalRiskPreventionKpiCfgService: OccupationalRiskPreventionKpiCfgService,
    private offersInNegotiationKpiCfgService: OffersInNegotiationKpiCfgService, private ordersKpiCfgService: OrdersKpiCfgService, private visitsCallsTargetsKpiCfgService: VisitsCallsTargetsKpiCfgService,
    private monthlyTargetsCfgService: MonthlyTargetsKpiCfgService, private discontinuousPermanentWorkersKpiCfgService: DiscontinuousPermanentWorkersKpiCfgService,
    private workersAppealKpiCfgService: WorkersAppealKpiCfgService, private pendingOrdersFDKpiCfgService: PendingOrdersFDKpiCfgService, private vacanciesKpiCfgService: VacanciesKpiCfgService,
    private contractsDirectKpiCfgService: ContractsDirectKpiCfgService,
    private occupationalRiskPreventionDirectKpiCfgService: OccupationalRiskPreventionDirectKpiCfgService, private absencesDirectKpiCfgService: AbsencesDirectKpiCfgService,
    private dashboardRecruitmentCfgService: DashboardRecruitmentCfgService, private commonCfgService: CommonCfgService,
    private noveltyCfgService: NoveltyCfgService,
    private powerBiCfgService: PowerBiCfgService,
    private showPowerBiCfgService: ShowPowerBiCfgService
  ) { }

  async ngOnInit(): Promise<void> {
    if (this.apigeeService.googleAuthToken != null
      && this.apigeeService.googleDirectoryToken != null
      && this.apigeeService.apiToken != null
    ) {
      try {
        this.zone.run(() => {
          this.mBusy = true;
          this.router.navigate(['/dashboard']);
        });
      } finally {
        this.zone.run(() => (this.mBusy = false));
      }
    }
    else {
      await this.getAuthToken();
    }
  }

  /**
   * Validar token de autorizacion
   */
  private getAuthToken(): void {

    const googleAuth = JSON.parse(localStorage.getItem('googleAuth'));

    if (!googleAuth?.access_token || !this.checkAuth(googleAuth.hd)) return;

    this.gapisService.getUserInfo(googleAuth.access_token).pipe(
      switchMap((info: any) => {
        const mail = info['email'];
        return this.gapisService.getDirectoryInfo(googleAuth.access_token, mail).pipe(
          switchMap((directoryInfo: any) => {
            this.apigeeService.storeGoogleTokens(googleAuth, directoryInfo);
            return this.apigeeService.requestToken(mail, googleAuth.access_token).pipe(
              switchMap(async () => {
                await this.loadUrlsConfiguration();
                return of(null)
              })
            )
          })
        );
      })
    ).subscribe({
      next: () => this.zone.run(() => this.router.navigate(["dashboard"])),
      error: (err) => this.zone.runGuarded(() => { throw err; }),
      complete: () => this.zone.run(() => (this.mBusy = false))
    });
  }

  private checkAuth(domain: string): boolean {
    if (domain && (domain === "randstad.es" || domain === "fundacionrandstad.es")) {
      return true;
    } else {
      return false;
    }
  }

  private async loadUrlsConfiguration() {
    const initializeImpersonate = async () => {
      await this.impersonationCfgService.initialize();
      await this.impersonationService.initialize();
    };

    await this.serverAddressesCfgService.initialize().then(async (_) => {
      await initializeCoreServices(
        this.accessManagerCfgService,
        initializeImpersonate,
        this.featurePermissionsCfgService,
        this.sigv4CfgService,
        this.appLinksCfgService,
        this.appLinksProfessionalsCfgService,
        this.officeSelectorCfgService,
        this.helpCfgService,
        this.launcherCfgService,
        this.smsCfgService,
        this.notificationHubCfgService,
        this.absencesKpiCfgService,
        this.dashboardCfgService,
        this.administrativeManagementDigitalizationKpiCfgService,
        this.bucketStatusKpiCfgService,
        this.contractsKpiCfgService,
        this.occupationalRiskPreventionKpiCfgService,
        this.offersInNegotiationKpiCfgService,
        this.ordersKpiCfgService,
        this.visitsCallsTargetsKpiCfgService,
        this.monthlyTargetsCfgService,
        this.discontinuousPermanentWorkersKpiCfgService,
        this.workersAppealKpiCfgService,
        this.pendingOrdersFDKpiCfgService,
        this.vacanciesKpiCfgService,
        this.contractsDirectKpiCfgService,
        this.occupationalRiskPreventionDirectKpiCfgService,
        this.absencesDirectKpiCfgService,
        this.dashboardRecruitmentCfgService,
        this.commonCfgService,
        this.noveltyCfgService,
        this.powerBiCfgService,
        this.showPowerBiCfgService);
    });
  }

}
